import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const StyledButtonContainer = withViewportStyle("div")`  
  .button-primitive {
    font-size: ${rem(15)};
    font-weight: 700;
    padding: ${rem(10)} ${rem(51)};
    line-height: ${rem(24)};
    max-width: ${rem(300)};
    width: max-content;
    
    ${(props) => props.$viewport.mobile`
      max-width: 100%;
      width: 100%;
    `}
  }
`;

export default StyledButtonContainer;
